//人力资源表
import {useState} from "react";
import {Form, Input, Descriptions, Button, Radio, Select, Table, Space, Checkbox, Typography, InputNumber} from "antd";
import {gql, useMutation, useSubscription} from "@apollo/client";
import {UploadOutlined} from '@ant-design/icons';
import {SelectUpload} from "./component/SelectUpload";
import {Attachments} from "./component/Attachments";
const {TextArea} = Input;
const {Title, Paragraph, Text, Link} = Typography;
export default  function Rlzy(){
    const [value, setValue] = useState(window.location.hash.split("?")[1] || '');

    const handleChange = (newValue) => {
        setValue(newValue);
        window.location.hash = (window.location.hash.split("?")[0] || window.location.hash) + '?' + newValue
    };

    const [form] = Form.useForm();
    const {data: theRDData, loading: theMndsbDataLoading} = useSubscription(
        gql`subscription MySubscription($id: uuid = "") {
  player_by_pk(id: $id) {
    IDNumber
    age
    created_at
    id
    mndsb
    name
    number
    post
    professional
    school
    updated_at
    xueli
    attachments {
      created_at
      description
      id
      item
      name
      path
      text
      updated_at
    }
    mndsbObj {
      _glykj
      _jscxgl
      _kjcgzh
      _zscqjz
      basics_cost
      china_cost
      company
      created_at
      ent_hr_abroed
      ent_hr_age1
      ent_hr_age2
      ent_hr_age3
      ent_hr_age4
      ent_hr_bachelor
      ent_hr_doctor
      ent_hr_ext
      ent_hr_forg
      ent_hr_junior
      ent_hr_master
      ent_hr_mechanic
      ent_hr_middle
      ent_hr_on_job
      ent_hr_part
      ent_hr_primary
      ent_hr_senior
      ent_hr_total
      ent_hr_tsdplan
      enterprise_income
      id
      net_asset1
      net_asset2
      net_asset3
      sales_revenue1
      sales_revenue2
      sales_revenue3
      sat_hr_abroed
      sat_hr_ext
      sat_hr_forg
      sat_hr_on_job
      sat_hr_part
      sat_hr_total
      total_profit1
      sat_hr_tsdplan
      total_profit2
      total_profit3
      updated_at
      year
      players {
        IDNumber
        age
        created_at
        id
        mndsb
        name
        number
        post
        professional
        school
        updated_at
        xueli
      }
    }
  }
}`, {
            variables: {id: value},
            shouldResubscribe: true
        },
    )
    const [update_player_by_pk, {error}] = useMutation(gql`mutation MyMutation($id: uuid = "", $player: player_set_input = {}) {
        update_player_by_pk(pk_columns: {id: $id}, _set: $player) {
            id
        }
    }
    `);
    const RlzyInitialValues = {...(theRDData || {}).player_by_pk};

    return(<>
        {(theRDData || {}).player_by_pk && <>
            <Form
                name="basic"
                labelCol={{
                    span: 32,
                }}
                wrapperCol={{
                    span: 32,
                }}
                style={{
                    maxWidth: 800,
                }}
                initialValues={RlzyInitialValues}
                onFinish={(values) => {
                    console.log(values)
                  update_player_by_pk({
                    variables: {
                      id: value,
                      player: values
                    }
                  }).fankui().then(value1 => window.history.back())

                }}
                onFinishFailed={(e) => {
                    console.error(e)
                }}
                autoComplete="off"
                form={form}
            >
                <Form.Item
                    label="姓名"
                    name="name"
                    rules={[{required: true, message: '请输入内容'}]}
                    style={{display: 'inline-flex', width: '50%'}}
                >
                    <Input/>
                </Form.Item>
                <Form.Item
                    label="年龄"
                    name="age"
                    rules={[{required: true, message: '请输入内容'}]}
                    style={{display: 'inline-flex', width: '50%'}}
                >
                    <InputNumber/>
                </Form.Item>
                <Form.Item
                    label="学历"
                    name="xueli"
                    rules={[{required: true, message: '请输入内容'}]}
                    style={{display: 'inline-flex', width: '50%'}}
                >
                    <Input/>
                </Form.Item>
                <Form.Item
                    label="毕业学校"
                    name="school"
                    rules={[{required: true, message: '请输入内容'}]}
                    style={{display: 'inline-flex', width: '50%'}}
                >
                    <Input/>
                </Form.Item>
                <Form.Item
                    label="职称"
                    name="professional"
                    rules={[{required: true, message: '请输入内容'}]}
                    style={{display: 'inline-flex', width: '50%'}}
                >
                    <Input/>
                </Form.Item>
                <Form.Item
                    label="身份证号"
                    name="IDNumber"
                    rules={[{required: true, message: '请输入内容'}]}
                    style={{display: 'inline-flex', width: '50%'}}
                >
                    <Input/>
                </Form.Item>
                <Form.Item
                    label="手机"
                    name="number"
                    rules={[{required: true, message: '请输入内容'}]}
                    style={{display: 'inline-flex', width: '50%'}}
                >
                    <Input/>
                </Form.Item>
                <Form.Item
                    label="工作岗位"
                    name="post"
                    rules={[{required: true, message: '请输入内容'}]}
                    style={{display: 'inline-flex', width: '50%'}}
                >
                    <Input/>
                </Form.Item>
                <h3>附件 <UploadOutlined/></h3>
                <SelectUpload
                    item={value}
                    nameList={["近一年1月、12月的社保缴纳证明", "企业职工工资表", "科技人员名单", "科技人员职称证书","学历证书","资格证书"]}/>
                <Attachments attachments={theRDData.player_by_pk.attachments}/>
                <Paragraph>
                    请上传企业职工和科技人员情况说明材料、包括在职、兼职和临时聘用人员人数、人员学历结构、科技人员名单及其工作岗位等。
                    <br/>
                  <h5>认定机构具体要求如下：</h5>
                    1. 近一年1月、12月的社保缴纳证明、企业职工工资表；<br/>
                    2. 科技人员名单（包括：姓名、年龄、学历、毕业院校、职称、身份证号、手机、工作岗位）；<br/>
                    3.科技人员职称证书、学历证书、资格证书等；<br/>
                    <h5>附件格式要求：</h5>

                    1、证明材料扫描上传。<br/>

                    2、只支持非加密PDF格式的文件上传。<br/>

                    3、单个文件大小不要超过2M。
                </Paragraph>
                <Form.Item wrapperCol={{offset: 8, span: 8}}>
                    <Button type="primary" htmlType="submit">
                        确定
                    </Button>
                </Form.Item>
            </Form>


        </>}
    </>)
}
